import { gql, type TypedDocumentNode } from '@apollo/client';

import { isType } from '@sorare/core/src/lib/gql';

import { TaskCards } from './TaskCards';
import { TaskCollections } from './TaskCollections';
import type {
  TaskCardsOrCollections_currentUser,
  TaskCardsOrCollections_taskInterface,
} from './__generated__/index.graphql';

type Props = {
  task: TaskCardsOrCollections_taskInterface;
  currentUser: Nullable<TaskCardsOrCollections_currentUser>;
};

export const TaskCardsOrCollections = ({ task, currentUser }: Props) => {
  if (isType(task, 'CardsCountTask')) {
    return <TaskCards task={task} />;
  }
  if (isType(task, 'CompleteCollectionsCountTask')) {
    return <TaskCollections task={task} currentUser={currentUser} />;
  }
  return null;
};

TaskCardsOrCollections.fragments = {
  taskInterface: gql`
    fragment TaskCardsOrCollections_taskInterface on TaskInterface {
      id
      ...TaskCards_taskInterface
      ...TaskCollections_taskInterface
    }
    ${TaskCards.fragments.taskInterface}
    ${TaskCollections.fragments.taskInterface}
  ` as TypedDocumentNode<TaskCardsOrCollections_taskInterface>,
  currentUser: gql`
    fragment TaskCardsOrCollections_currentUser on CurrentUser {
      slug
      ...TaskCollections_currentUser
    }
    ${TaskCollections.fragments.currentUser}
  ` as TypedDocumentNode<TaskCardsOrCollections_currentUser>,
};
